// نصوص تقرير «الرواتب الموقوفة» المطبوع (عربي/إنجليزي).
export const HL = {
  ar: {
    title: "تقرير الرواتب الموقوفة",
    subtitle: "جميع الفروع",
    generatedAt: "تاريخ إنشاء التقرير",
    cards: ["عدد الموظفين الموقوفين", "إجمالي أيام الغياب", "عدد الفروع", "آخر فحص تلقائي"],
    cols: ["الموظف", "البريد", "الفرع", "أيام الغياب", "تواريخ الغياب", "تاريخ الإيقاف"],
    rulesTitle: "قواعد إيقاف الراتب (حسب إعدادات كل فرع)",
    ruleBranch: "{n} أيام غياب متتالية بدون إجازة = إيقاف الراتب",
    ruleDisabled: "إيقاف الراتب عند الغياب المتتالي معطّل في إعدادات الفرع",
    ruleDeduction: "خصم كل يوم غياب = {n} يوم من الراتب",
    ruleNoDeduction: "خصم الغياب معطّل في إعدادات الفرع",
    note1: "الراتب الموقوف لا يُصرف حتى موافقة مدير الشركة أو الموارد البشرية.",
    note2: "العطل الرسمية وأيام الراحة والإجازات المعتمدة لا تُحتسب غياباً.",
    empty: "لا يوجد موظفون موقوفة رواتبهم",
    print: "طباعة", close: "إغلاق", share: "مشاركة التقرير", copyLink: "نسخ الرابط",
    downloadPdf: "تحميل PDF", sharePdf: "مشاركة PDF",
    copied: "تم نسخ الرابط", shareNote: "الرابط عام وصالح 7 أيام",
    reference: "الرقم المرجعي:",
    signTitle: "التوقيع والاعتماد",
    signRoles: ["أعدّه (الموارد البشرية)", "راجعه (المالية)", "اعتمده (المدير العام)"],
    signNameDate: "الاسم والتاريخ",
    signNote: "هذا التقرير صادر إلكترونياً من نظام HELCOO، والتزام الموقّعين أعلاه مأخوذ من الفروع وإعداداتها.",
    footer: "تقرير الرواتب الموقوفة — HELCOO",
  },
  en: {
    title: "Held salaries report",
    subtitle: "All branches",
    generatedAt: "Generated at",
    cards: ["Employees on hold", "Total absence days", "Branches", "Last automatic scan"],
    cols: ["Employee", "Email", "Branch", "Absence days", "Absence dates", "Held on"],
    rulesTitle: "Salary hold rules (per branch settings)",
    ruleBranch: "{n} consecutive unexcused absence days = salary on hold",
    ruleDisabled: "Salary hold on consecutive absence is disabled for this branch",
    ruleDeduction: "each absent day deducts {n} day(s) of salary",
    ruleNoDeduction: "absence deduction is disabled for this branch",
    note1: "A held salary is not paid until the company admin or HR approves it.",
    note2: "Public holidays, weekends and approved leaves are not counted as absence.",
    empty: "No employees have a held salary",
    print: "Print", close: "Close", share: "Share report", copyLink: "Copy link",
    downloadPdf: "Download PDF", sharePdf: "Share PDF",
    copied: "Link copied", shareNote: "The link is public and valid for 7 days",
    reference: "Reference:",
    signTitle: "Signatures and approval",
    signRoles: ["Prepared by (HR)", "Reviewed by (Finance)", "Approved by (General Manager)"],
    signNameDate: "Name and date",
    signNote: "This report is issued electronically by HELCOO based on each branch's payroll settings.",
    footer: "Held salaries report — HELCOO",
  },
};
